import { Component, EventEmitter, Input, Output } from "@angular/core"
import { Roster } from "../../../../models/roster.model"
import { ModalRef } from "../../../modal/modal-ref"

@Component({
    selector: "app-select-class-view",
    templateUrl: "./select-class-view.component.html",
    styleUrls: ["./select-class-view.component.scss"],
})
export class SelectClassViewComponent {
    @Input() public rosters: Roster[] = []
    @Input() public activeModal: ModalRef = null
    @Output() public step = new EventEmitter<number>()

    public googleClassImg: string = ""

    public constructor() {
        this.googleClassImg = require("../../../../../assets/classroom-color-round.png").default
    }

    public checkIfSelected() {
        if (this.rosters) {
            return !!this.rosters.find((roster: Roster) => roster.selected)
        }
        return false
    }

    public next() {
        this.step.emit(2)
    }

    public prev() {
        this.step.emit(0)
    }
}
